// extracted by mini-css-extract-plugin
module.exports = {"comp4":"Sect3_Component4_comp4__2KqJb","left":"Sect3_Component4_left__3H428","right":"Sect3_Component4_right__2dFzS"};